export const EDI_FLOWS_TYPES = {
  ORDER: 'order',
  BLI: 'bli',
  PLANNING: 'planning',
};
